import { useCallback, useState } from 'react';
import { patchAdminProfile } from './actions';
import { IUpdateAdminProfile, UseProfileReturnType } from './types';

export function useProfile(): UseProfileReturnType {
	const [loading, setLoading] = useState<boolean>(false);

	const editAdminProfile = useCallback(
		async (
			updatedObject: IUpdateAdminProfile,
			onSuccess?: () => void,
			onError?: () => void
		) => {
			try {
				setLoading(true);
				const response = await patchAdminProfile(updatedObject);
				if (response === 200) {
					onSuccess && onSuccess();
				} else if (response === 400) {
					onError && onError();
				}
			} catch {
				onError && onError();
			} finally {
				setLoading(false);
			}
		},
		[]
	);

	return {
		editAdminProfile,
		loading
	};
}
